export function assert(value: unknown, message?: string): asserts value {
  if (!value) {
    throw new Error(
      `AssertionError: ${message ?? 'expected value to be truthy'}`,
    );
  }
}
